import React from "react";

const Alerts = ({ type, title, message }) => {
  let colors = ''
  switch (type) {
    case 'danger':
      colors = 'text-red-600 bg-red-200 border-red-600'
      break;
    case 'info':
      colors = 'text-blue-600 bg-blue-200 border-blue-600'
      break;
    default:
      colors = 'text-green-600 bg-green-200 border-green-600 text-green-600'
      break;
  }
  return (
    <div className={`${colors}  border-l-4 p-4 w-full text-center mt-0 md:mt-2`} role="alert">
      <p className="font-bold">
        { title }  
      </p>
      <p>
        { message }
      </p>
    </div>
  );
}

export default Alerts


